import React from "react";
import { ShoppingCart, X } from "lucide-react";
import CartLineItem from "./CartLineItem";
import { formatMoney, useCart } from "../../context/CartContext";

export default function CartPanel({ onClose, onCheckout }) {
  const { lines, itemCount, subtotalCents, taxCents, totalCents, clearCart } = useCart();

  return (
    <div className="flex h-full flex-col bg-white">
      <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
        <h2 className="flex items-center gap-2 text-base font-semibold text-gray-900">
          <ShoppingCart className="h-5 w-5" /> Your cart
          {itemCount > 0 && <span className="rounded-full bg-blue-50 px-2 py-0.5 text-xs font-semibold text-blue-700">{itemCount}</span>}
        </h2>
        <div className="flex items-center gap-1">
          {lines.length > 0 && (
            <button type="button" onClick={clearCart} className="rounded px-2 py-1 text-xs font-medium text-gray-500 hover:bg-gray-100 hover:text-red-600">
              Clear
            </button>
          )}
          {onClose && (
            <button type="button" onClick={onClose} className="rounded p-1 text-gray-500 hover:bg-gray-100" aria-label="Close cart">
              <X className="h-5 w-5" />
            </button>
          )}
        </div>
      </div>

      {lines.length === 0 ? (
        <div className="flex flex-1 flex-col items-center justify-center px-6 py-12 text-center">
          <ShoppingCart className="mb-3 h-10 w-10 text-gray-300" aria-hidden="true" />
          <p className="font-medium text-gray-900">Your cart is empty</p>
          <p className="mt-1 text-sm text-gray-500">Search for a product and tap Add.</p>
        </div>
      ) : (
        <>
          <ul className="flex-1 divide-y divide-gray-100 overflow-y-auto px-4">
            {lines.map((line) => (
              <CartLineItem key={line.key} line={line} />
            ))}
          </ul>

          <div className="space-y-2 border-t border-gray-100 px-4 py-4 text-sm">
            <div className="flex justify-between text-gray-600">
              <span>Subtotal</span>
              <span className="tabular-nums">{formatMoney(subtotalCents)}</span>
            </div>
            <div className="flex justify-between text-gray-600">
              <span>Tax</span>
              <span className="tabular-nums">{formatMoney(taxCents)}</span>
            </div>
            <div className="flex justify-between border-t border-gray-100 pt-2 text-base font-semibold text-gray-900">
              <span>Total</span>
              <span className="tabular-nums">{formatMoney(totalCents)}</span>
            </div>
            <button
              type="button"
              onClick={onCheckout}
              disabled={!onCheckout}
              className="mt-2 w-full rounded-xl bg-blue-600 py-3 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500"
            >
              {onCheckout ? "Place order" : "Checkout coming soon"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
